var $f2d0cee72cb9c606$exports = {};
$f2d0cee72cb9c606$exports = {
    "alert": `Varsel`,
    "dismiss": `Lukk`
};


export {$f2d0cee72cb9c606$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
